import { type Block, isField } from "@fobu/schema";
import { useFormEnv } from "../lib/context";
import { Markdown } from "../lib/markdown";
import { FieldView } from "./FieldView";
import { DocumentBlock, ImageBlock, VideoBlock } from "./MediaBlocks";
import { Divider } from "./Divider";

/** Inhaltsblöcke und Felder. Externe Video-Plattformen werden bewusst nicht eingebettet (DSGVO). */
export function BlockView({ block, large, number }: { block: Block; large?: boolean; number?: number }) {
  const { tpl } = useFormEnv();
  if (isField(block)) return <FieldView field={block} large={large} number={number} />;
  switch (block.type) {
    case "heading": {
      const Tag = (`h${Math.min(block.level + 1, 4)}` as "h2" | "h3" | "h4");
      return (
        <Tag class={`fb-heading fb-heading--${block.level}`}>
          <Markdown text={tpl(block.text)} />
        </Tag>
      );
    }
    case "paragraph":
      return (
        <div class="fb-paragraph">
          <Markdown text={tpl(block.text)} as="p" />
        </div>
      );
    case "banner":
      return (
        <div class={`fb-banner fb-banner--${block.tone}`} role={block.tone === "danger" || block.tone === "warning" ? "note" : undefined}>
          <Markdown text={tpl(block.text)} as="p" />
        </div>
      );
    case "image":
      return <ImageBlock block={block} />;
    case "video":
      return <VideoBlock block={block} />;
    case "divider":
      return <Divider block={block} />;
    case "document":
      return <DocumentBlock block={block} />;
  }
}
